import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchPartnerContentClient } from 'src/services/contentstack/fetchPartnerContentClient';
import type { ContentstackPartner } from 'src/services/contentstack/types/PartnerPage.types';

export interface RequestPartnerContentOptions {
  shortcode: string;
}

export const requestPartnerContent = createAsyncThunk<
  ContentstackPartner | null,
  RequestPartnerContentOptions
>('partner/requestPartnerContent', async ({ shortcode }) => {
  const data = await fetchPartnerContentClient(shortcode);

  return data;
});
